import { useState } from "react";
import LoadingCircle from "../utility/LoadingCircle";
import SignaturePad from "./SignaturePad";

export default function ApproveDesignButton({ projectId, tempToken, api, setStage }) {
	const [openModal, setOpenModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const [signatureData, setSignatureData] = useState(null);
	const [signer, setSigner] = useState("");

	const getReport = () => {
		setLoading(true);
		fetch(api + "/report/" + projectId, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/pdf",
				Authorization: "Bearer " + tempToken,
			},
			body: JSON.stringify({
				signer: signer,
				signatureData: signatureData,
			}),
		})
			.then((response) => {
				if (!response.ok) {
					if (response.status === 403) {
						alert("You do not have permission to create this report");
					} else {
						alert("An error occurred while creating the report. Please try again.");
					}
				}
				return response.blob();
			})
			.then((blob) => {
				if (blob) {
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement("a");
					a.href = url;
					a.download = `project_${projectId}.pdf`;
					document.body.appendChild(a);
					a.click();
					a.remove();
					window.URL.revokeObjectURL(url);
					setStage("completed");
				}
			})
			.finally(() => {
				setLoading(false);
				setOpenModal(false);
				setSignatureData(null);
				setSigner("");
			})
			.catch((error) => {
				console.error("Error downloading PDF:", error);
			});
	};

	if (loading && openModal) {
		return (
			<div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-50 z-[2000] flex justify-center items-center">
				<div className="bg-white text-black p-4 rounded-md shadow-lg flex justify-center items-center flex-col">
					<LoadingCircle />
					<p>Approving Design...</p>
				</div>
			</div>
		);
	}

	return (
		<>
			{openModal ? (
				<div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-50 z-[2000] flex justify-center items-center">
					<div className="bg-white text-black p-4 rounded-md shadow-lg w-full md:w-2/5">
						<div className="flex flex-col justify-between items-center mb-6">
							<p className="text-2xl font-bold ">Approve Design</p>
							<p className="text-center mb-4 font-semibold">Signing and submitting this design will create a PDF</p>
							<p className="text-center text-sm bg-yellow-100">
								Ensure you have filled out all the fields highlighted in yellow as you will not be able to edit after approving.
							</p>
						</div>
						<div className="my-10">
							<SignaturePad setSignatureData={setSignatureData} />
							<label>Signer:</label>
							<input type="text" value={signer} onChange={(e) => setSigner(e.target.value)} className="border border-black  w-full p-1 mt-1" />
						</div>

						<div className="mt-5 flex justify-center gap-2">
							<button onClick={() => setOpenModal(false)} className="bg-gray-500 hover:bg-gray-600 text-white p-2  rounded-md">
								Close
							</button>

							<button
								disabled={!signer || !signatureData}
								onClick={getReport}
								className={`p-2 text-lg text-white rounded-md ${
									!signer || !signatureData ? "bg-gray-500" : " bg-blue-600 hover:bg-blue-700"
								} `}>
								Approve Design
							</button>
						</div>
					</div>
				</div>
			) : null}
			<div>
				<button onClick={() => setOpenModal(true)} className="p-2 text-lg text-white rounded-md bg-blue-600 hover:bg-blue-700 ">
					Approve design
				</button>
			</div>
		</>
	);
}
